import styled from "styled-components/macro";
import useQueryString from "utils/customHooks/useQueryString";
import { DateAndShiftPickerMode } from "./DateAndShiftPickerMode/DateAndShiftPickerMode";
import { DateRangePickerMode } from "./DateRangePickerMode/DateRangePickerMode";
import { useGetPageFromPath } from "utils/customHooks/genericHooks";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import { useIsDarkMode } from "store/atoms";
import { useIsStorybook } from "utils/customHooks/storyHooks";
import { darkGrey, darkModeCardBackgroundColor } from "constants/colors";
import { BREAKPOINT_DESKTOP_XL } from "constants/constants";
import "./rangeSelectorToggleable.css";

export function RangeSelectorToggleable({
  autoSubmit,
}: {
  /** whenever user changes the date range using this picker, they normally have to click submit button, this prevents spamming server with unnecessary requests; use `autoSubmit` if the picker is on a page which doesn't fetch data to simplify the picking process (removes submit/clear buttons) */
  autoSubmit?: boolean;
}) {
  const parsedQuery = useQueryString();
  const { isTrendsPage, isSnapshotsPage } = useGetPageFromPath();
  const isStorybook = useIsStorybook();
  const isDateRangeMode =
    isTrendsPage ||
    (parsedQuery.ge && parsedQuery.lt && !isStorybook) ||
    isSnapshotsPage;

  const [isDarkMode] = useIsDarkMode();

  return (
    <ErrorBoundary id={"RangeSelectorToggleable"}>
      <RangeSelectorToggleableStyles
        {...{ $isDarkMode: isDarkMode }}
        className="RangeSelectorToggleableStyles"
      >
        {isDateRangeMode ? (
          // 2+yrs old picker
          <DateRangePickerMode {...{ autoSubmit }} />
        ) : (
          // new 2022-12
          <DateAndShiftPickerMode />
        )}
      </RangeSelectorToggleableStyles>
    </ErrorBoundary>
  );
}

const RangeSelectorToggleableStyles = styled.div<{ $isDarkMode: boolean }>`
  width: 100%;
  box-sizing: border-box;
  background: ${props =>
    props.$isDarkMode ? darkModeCardBackgroundColor : "white"};
  font-family: "Open Sans";
  .rangeSelectorConfigMenu .MuiCollapse-wrapper {
    transform: translateY(-29px);
  }
  .MuiButtonBase-root .MuiSvgIcon-root {
    color: ${darkGrey};
  }
  .DateAndShiftPickerStyles {
    /* horizontal layout */
    max-width: 1160px;
    @media (min-width: ${BREAKPOINT_DESKTOP_XL}px) {
      max-width: 80vw;
    }
    margin: auto;
  }
`;
